import React from 'react'
import ReactDOM from 'react-dom/client'
import { App } from '@/app/App'
import { ConfigErrorScreen } from '@/app/ConfigErrorScreen'
import { env, envResult } from '@/config/env'
import '@/index.css'

async function enableMocks() {
  if (!env.useMockApi) return
  // Import dinâmico: MSW e os handlers não entram no bundle quando o mock está desligado.
  const { startMockWorker } = await import('@/mocks/browser')
  await startMockWorker()
}

async function bootstrap() {
  const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
  if (!envResult.ok) {
    root.render(<ConfigErrorScreen errors={envResult.errors} />)
    return
  }
  await enableMocks()
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  )
}

void bootstrap()
